import moment from "moment";

const getRange = (startDate, endDate, type) => {
  let fromDate = moment(startDate);
  let toDate = moment(endDate);
  let diff = toDate.diff(fromDate, type);
  let range = [];

  for (let i = 0; i < diff; i++) {
    range.push(moment(startDate).add(i, type));
  }

  return range;
};

export const mainCategoryMapper = (
  thingsToDo,
  thingsToEat,
  fromDate,
  toDate
) => {
  let thingsToDoRangeCounter = {};
  let thingsToEatRangeCounter = {};
  let range = getRange(fromDate, toDate, "days");
  let dates = range.map(date => {
    return date.format("MM/DD");
  });
  let thingsToEatSeries = [];
  let thingsToDoSeries = [];

  for (let d in range) {
    let date = range[d].format("YYYY-MM-DD");
    thingsToDoRangeCounter[date] = thingsToDoRangeCounter[date] || 0;
    thingsToEatRangeCounter[date] = thingsToEatRangeCounter[date] || 0;
  }

  for (let i in thingsToDo) {
    let dateStr = thingsToDo[i].event_date;
    let year = dateStr.substring(0, 4);
    let month = dateStr.substring(4, 6);
    let day = dateStr.substring(6);
    let eventDate = `${year}-${month}-${day}`;
    thingsToDoRangeCounter[eventDate]++;
  }

  for (let i in thingsToEat) {
    let dateStr = thingsToEat[i].event_date;
    let year = dateStr.substring(0, 4);
    let month = dateStr.substring(4, 6);
    let day = dateStr.substring(6);
    let eventDate = `${year}-${month}-${day}`;
    thingsToEatRangeCounter[eventDate]++;
  }

  for (let i in thingsToDoRangeCounter) {
    thingsToDoSeries.push(thingsToDoRangeCounter[i]);
  }

  for (let i in thingsToEatRangeCounter) {
    thingsToEatSeries.push(thingsToEatRangeCounter[i]);
  }

  return {
    labels: dates,
    series: [thingsToDoSeries, thingsToEatSeries],
  };
};

export const destinationRequestMapper = (requests, fromDate, toDate) => {
  let range = getRange(fromDate, toDate, "days");
  let dates = range.map(date => {
    return date.format("MM/DD");
  });
  let requestRangeCounter = {};
  let requestSeries = [];

  for (let d in range) {
    let date = range[d].format("YYYY-MM-DD");
    requestRangeCounter[date] = requestRangeCounter[date] || 0;
  }

  for (let i in requests) {
    let dateStr = requests[i].event_date;
    let year = dateStr.substring(0, 4);
    let month = dateStr.substring(4, 6);
    let day = dateStr.substring(6);
    let eventDate = `${year}-${month}-${day}`;
    requestRangeCounter[eventDate]++;
  }

  for (let i in requestRangeCounter) {
    requestSeries.push(requestRangeCounter[i]);
  }

  return {
    labels: dates,
    series: [requestSeries],
  };
};

export const categoryClicksMapper = (clicks) => {
  let clickFreqCounter = {};

  for (let click in clicks) {
    let name = clicks[click].params.value.string_value;
    clickFreqCounter[name] = (clickFreqCounter[name] || 0) + 1;
  }

  let category_clicks = Object.keys(clickFreqCounter).map((event) => {
    return { name: event, count: clickFreqCounter[event] };
  });

  return category_clicks.sort((a, b) => (a.count < b.count ? 1 : -1));
};
